// Document detail / peek — CLEARED FOR REDESIGN.
//
// The old detail screen (header, lines table, ledger effect, comms log, activity timeline,
// share link) has been removed so the Sales / Purchases document UX can be redesigned from
// scratch. `documentDetailScreen` now renders a single placeholder — no data is loaded.
import { html } from '../shared/t4.js';
import { tenantShell } from './tshell.js';
import { DOC_TYPES } from './documents.js';


export function documentDetailScreen(companyId, docKey, docId){
  const cfg = DOC_TYPES[docKey] || {};
  const label = cfg.noun || cfg.label || docKey || 'Document';
  const family = cfg.group === 'purchase' ? 'Purchases' : 'Sales';
  return tenantShell(companyId, label, html`
    <div class="page page-wide">
      <div class="page-head">
        <div>
          <span class="eyebrow">${family}</span>
          <h1>${label} ${docId ? '#' + docId : ''}</h1>
        </div>
      </div>
      <div class="card muted detail-placeholder">
        <h2 class="detail-placeholder-title">Cleared for redesign</h2>
        <p class="detail-placeholder-copy">
          The document detail view is being redesigned. This screen is intentionally blank while
          the new UX lands.
        </p>
      </div>
    </div>
  `);
}
